export const languages = [
  {
    code: 'es',
    name: 'Español',
    flag_code: 'es',
  },
  {
    code: 'en',
    name: 'English',
    flag_code: 'gb',
  },
];

// export const LANG_COOKIE = 'i18next';